export default {
  quoteDistribution: {},
  quoteDistributionItem: {},
  quoteDistributions: [],
  periods: [],
  financeAcceptedLetterQuote: {},
  otmItmAcceptedLetterQuotes: [],
  balance: [],
}
